import { render, staticRenderFns } from "./GestioneSintetica.vue?vue&type=template&id=29e3b322&scoped=true&"
import script from "./GestioneSintetica.vue?vue&type=script&lang=js&"
export * from "./GestioneSintetica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e3b322",
  null
  
)

export default component.exports